import { useTranslation } from 'react-i18next';
import { AutoManagedJoinedInfluencer } from '@anytag/graphql';
import { TableCell, Anchor } from '@anytag/shared-atoms';
import { useGenerateInfluencerProfileLink } from '@anytag/shared-hooks';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { ColumnDef } from '@tanstack/react-table';

export const useAutoManagedJoinedInfluencersTable = () => {
  const { t } = useTranslation();
  const { generateProfileLink } = useGenerateInfluencerProfileLink();

  const columns: ColumnDef<AutoManagedJoinedInfluencer>[] = [
    {
      accessorKey: 'influencer',
      header: t<string>('HeaderColumn.Influencer'),
      cell: ({ row }) => {
        const { influencer } = row.original;
        const profileLink = generateProfileLink(influencer.id);

        return (
          <div className="flex min-w-50 items-center">
            <InfluencerAvatar
              size="48px"
              src={influencer.avatar}
              className="rounded-none bg-black-20"
              id={influencer.id}
            />
            <Anchor label={influencer.name} className="ml-2" {...profileLink} />
          </div>
        );
      }
    },
    {
      accessorKey: 'promotionMethods',
      header: t<string>('HeaderColumn.Social Media / Promotion method'),
      cell: ({ row }) => <TableCell.Text value={row.original.promotionMethods.join(', ') || '-'} />
    },
    {
      accessorKey: 'joinedDate',
      header: t<string>('HeaderColumn.Joined Date'),
      cell: ({ row }) => <TableCell.Date value={row.original.joinedDate} />
    }
  ];

  return { columns };
};
